import { render, staticRenderFns } from "./PublishBtn.vue?vue&type=template&id=11dfbe41&"
import script from "./PublishBtn.vue?vue&type=script&lang=js&"
export * from "./PublishBtn.vue?vue&type=script&lang=js&"
import style0 from "./PublishBtn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports